import styles from './index.module.css';

const defaultProps = {
  title: 'Authorization',
};

function AuthLayout({ children }) {
  return (
    <div className={styles.container}>
      <div className={styles.mainContent}>{children}</div>
    </div>
  );
}

AuthLayout.defaultProps = defaultProps;
export default AuthLayout;
